import { Component, ChangeDetectionStrategy, ElementRef, AfterViewInit, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'app-index-card-2',
  imports: [MatCardModule, MatIconModule, MatDividerModule],
  templateUrl: './index-card-2.component.html',
  styleUrl: './index-card-2.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IndexCard2Component implements AfterViewInit {
  private el = inject(ElementRef);

  ngAfterViewInit(): void {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const root = this.el.nativeElement as HTMLElement;

    const revealEl = (el: HTMLElement, delay: number): void => {
      if (prefersReduced) { el.classList.add('visible'); return; }
      const io = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => el.classList.add('visible'), delay);
          io.disconnect();
        }
      }, { threshold: 0.12 });
      io.observe(el);
    };

    const title = root.querySelector<HTMLElement>('.section-title');
    if (title) revealEl(title, 0);

    root.querySelectorAll<HTMLElement>('.stack-card').forEach((card, i) => revealEl(card, i * 120));
  }
  techStack = [
    { category: 'Cloud Platforms',            cssClass: 'cat-cloud',       icon: 'cloud',       tools: ['AWS', 'Google Cloud', 'Microsoft Azure'] },
    { category: 'CI/CD',                      cssClass: 'cat-cicd',        icon: 'sync_alt',    tools: ['GitHub Actions', 'Jenkins', 'AWS CodePipeline', 'GCP Cloud Build'] },
    { category: 'Containers & Orchestration', cssClass: 'cat-containers',  icon: 'grid_view',   tools: ['Docker', 'Kubernetes', 'AWS EKS', 'AWS ECS', 'GKE'] },
    { category: 'Infrastructure as Code',     cssClass: 'cat-iac',         icon: 'terminal',    tools: ['Terraform', 'Ansible'] },
    { category: 'Monitoring & Observability', cssClass: 'cat-monitoring',  icon: 'analytics',   tools: ['Datadog', 'Prometheus', 'Grafana', 'New Relic', 'AWS CloudWatch'] }
  ];
}
